import { Flex, Typography } from "antd"
import React, { type ReactNode } from "react"

import { WorkspaceCardValue } from "../cards/WorkspaceCardValue.tsx"

const { Text } = Typography

interface LeadOverviewFieldProps {
  label: string
  value?: ReactNode
  placeholder?: string
  children?: ReactNode
  /** Purely decorative — a small glyph in front of the label (e.g. a pin on an address). */
  icon?: ReactNode
}

function LeadOverviewField({
  label,
  value,
  placeholder,
  children,
  icon
}: LeadOverviewFieldProps) {
  return (
    <Flex vertical gap={2} className={"min-w-0"}>
      <Flex align={"center"} gap={4}>
        {icon}
        <Text type={"secondary"} className={"text-xs"}>
          {label}
        </Text>
      </Flex>
      {/* A field that only renders a control has no value of its own to miss. */}
      <WorkspaceCardValue
        value={value === undefined && children != null ? true : value}
        placeholder={placeholder}
      >
        {children}
      </WorkspaceCardValue>
    </Flex>
  )
}

export { LeadOverviewField }
